// import { capitalize } from 'lodash';

import { capitalize } from 'lodash';

import { Group } from '@/common/components/FilterDrawer/FilterDrawer';
import { FilterType } from '@/common/const/filterTypes';
import { SelectType } from '@/common/const/selectTypes';
import { VariableState } from '@/constants';

// import { VariableState } from '@/constants';

const getOwnerFilters = (filters?: { [key: string]: any }) => {
  const groupFilters = [];

  if (!filters?.mineOnly) {
    groupFilters.push(
      {
        label: 'Created By',
        name: filters?.defaultOwner ? 'defaultOwner' : 'createdBy',
        selectType: SelectType.USER,
        placeholder: 'Select created by',
      },
      {
        label: 'Product Owner',
        name: 'productOwner',
        selectType: SelectType.USER,
        placeholder: 'Select product owner',
      },
    );
  }

  groupFilters.push({
    label: 'Product Name',
    name: 'productEntity',
    selectType: SelectType.PRODUCT_ENTITY,
    placeholder: 'Select product name',
  });

  if (!filters?.mineOnly) {
    groupFilters.push({
      label: 'Engineering Owner',
      name: 'technicalOwner',
      selectType: SelectType.USER,
      placeholder: 'Select engineering owner',
    });
  }

  groupFilters.push({
    label: 'Tech Family',
    name: 'techFamily',
    selectType: SelectType.TECH_FAMILY,
    placeholder: 'Select tech family',
  });

  const ownerFilters: Group = {
    label: 'Owners',
    fields: groupFilters,
  };

  return ownerFilters;
};

export function getConfigurationsFilters(filters?: {
  [key: string]: any;
}): Group[] {
  return [
    {
      label: 'Main',
      fields: [
        {
          label: 'Variable Type',
          name: 'type',
          selectType: SelectType.TYPE,
          placeholder: 'Select Data Type',
        },
        {
          label: 'Variable State',
          name: !filters?.states ? 'defaultState' : 'states',
          multiple: true,
          options: [
            {
              label: capitalize(VariableState.ACTIVE),
              value: VariableState.ACTIVE,
              color: 'blue',
            },
            {
              label: capitalize(VariableState.INACTIVE),
              value: VariableState.INACTIVE,
              color: 'blue',
            },
            {
              label: capitalize(VariableState.ARCHIVED),
              value: VariableState.ARCHIVED,
              color: 'default',
            },
          ],
          placeholder: 'Select State(s)',
        },
      ],
    },
    getOwnerFilters(filters),
    {
      label: 'Tech',
      fields: [
        {
          label: 'Domain',
          name: 'domain',
          selectType: SelectType.DOMAIN,
          placeholder: 'Select the domain this variable will be experiment in',
        },
        {
          label: 'Primary Service',
          name: 'backend',
          selectType: SelectType.BACKEND,
          placeholder: 'Select primary service',
        },
        {
          label: 'Subscribed Services',
          name: 'subscribedServices',
          selectType: SelectType.SUBSCRIBED_SERVICES,
          placeholder: 'Select subscribed services',
        },
      ],
    },
    {
      label: 'Health',
      fields: [
        {
          label: 'Complexity Classification',
          name: 'complexityLevels',
          multiple: true,
          options: [
            { label: 'Healthy', value: 'healthy' },
            { label: 'Caution', value: 'caution' },
            { label: 'Severe', value: 'severe' },
          ],
          placeholder: 'Select complexity level(s)',
        },
        {
          label: 'Guardrail Violated: Documentation',
          name: 'guardrailViolated_documentation',
          type: FilterType.BOOLEAN,
        },
        {
          label: 'Guardrail Violated: Mandatory Facet',
          name: 'guardrailViolated_mandatory_facet',
          type: FilterType.BOOLEAN,
        },
        {
          label: 'Guardrail Violated: Validation',
          name: 'guardrailViolated_validation',
          type: FilterType.BOOLEAN,
        },
        {
          label: 'Guardrail Violated: Owners',
          name: 'guardrailViolated_owners',
          type: FilterType.BOOLEAN,
        },
      ],
    },
  ];
}
